export default {
      id: "ic-fil-tv-light-green-usage",
      viewBox: "0 0 19 18",
      url: "/" + "images/icons.3.109.2.svg#ic-fil-tv-light-green-usage",
      toString: function () {
        return this.url;
      }
    }